import { render, staticRenderFns } from "./ReminderDownload.vue?vue&type=template&id=70d06391&"
import script from "./ReminderDownload.vue?vue&type=script&lang=js&"
export * from "./ReminderDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports